export const BANNER_LIST = [
  {
    id: 1,
    image: '/assets/banner/yena.png',
    link: 'https://youtu.be/NOiyDlWl534?si=y6d94fXoQVixuEtN',
    name: 'yena',
  },
];
